import styled from 'styled-components';
import { rem } from 'polished';
var Main = styled.div.withConfig({
  displayName: "Main",
  componentId: "ru6wxf-0"
})(["align-items:center;display:flex;min-height:", ";padding:", " 0;"], function (_ref) {
  var viewportHeight = _ref.viewportHeight;
  return viewportHeight ? viewportHeight + "vh" : 'auto';
}, rem(64));
export default Main;